module.exports = __webpack_public_path__ + "img/banner-7.713de68c.jpg";